import type { ComposeStore } from './schema/ComposeStore';
import type { ComposeViewState } from './schema/ComposeViewState';
import { ObservableMap } from 'mobx';
import { createStore } from 'satcheljs';

const composeStoreData: ComposeStore = {
    viewStates: new ObservableMap<string, ComposeViewState>(),
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (11,5): Type 'null' is not assignable to type 'string'.
    // @ts-expect-error
    primaryComposeId: null,
    newMessageCreationInProgress: false,
};

export const getStore = createStore<ComposeStore>('compose', composeStoreData);

export const composeStore = getStore();
